module.exports = __webpack_public_path__ + "img/gaming.1508ff04.svg";